import React from 'react';
import Select from 'react-select';
import LoadingIcon from '../../../../LoadingIcon';
import ClientService from '../../../../../Services/clientService';
import ErrorMessage from '../../../../ErrorMessage';
import stringHelper from '../../../../../Helpers/stringHelper';
import dsSelectStyles from '../reactSelectDsStyles';

const MAX_DISPLAYED_OPTIONS = 100;

export default class ClientMultiChoiceAll extends React.Component {
  static defaultProps = {
    label: '',
    onChange: () => alert('ClientMultiChoiceAll Onchange'),
    selected: [],
    fieldName: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      inputValue: '',
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    ClientService.GetClientListIncludingInactive()
      .then((result) => {
        const optValues = [];
        result.forEach((client) => {
          if (!!client.name) {
            optValues.push({
              label: client.name + stringHelper.toBracket(client.clientId),
              value: client.clientId,
            });
          }
        });
        this.setState({ itemList: optValues, loading: false });
      })
      .catch(() => {
        this.setState({ itemList: [], loading: false });
        ErrorMessage.SetErrorMessage('CMCA61');
      });
  }

  getSelectedOptions() {
    if (!this.props.selected) return [];
    return this.state.itemList.filter((o) => this.props.selected.some((x) => x.toString() === o.value.toString()));
  }

  // The full client list is ~8k items; rendering them all makes the menu very slow
  // to open. Only the first MAX_DISPLAYED_OPTIONS matches of the typed filter are
  // offered, so filtering happens here and react-select's own filter is disabled.
  getDisplayedOptions() {
    const filter = this.state.inputValue.toLowerCase();
    const matching = filter
      ? this.state.itemList.filter((o) => o.label.toLowerCase().includes(filter))
      : this.state.itemList;
    return matching.slice(0, MAX_DISPLAYED_OPTIONS);
  }

  handleInputChange(inputValue) {
    this.setState({ inputValue });
    return inputValue;
  }

  multiSelectOnChange(selected) {
    this.props.onChange((selected || []).map((i) => i.value.toString()));
  }

  render() {
    return (
      <div className='w-100'>
        {this.state.loading ? (
          <LoadingIcon
            loading={true}
            className='h6'
          />
        ) : (
          <Select
            options={this.getDisplayedOptions()}
            value={this.getSelectedOptions()}
            isMulti={true}
            onChange={this.multiSelectOnChange}
            onInputChange={this.handleInputChange}
            filterOption={() => true}
            placeholder='Type to search clients...'
            // Portal the menu so it isn't clipped by the panel's scroll container.
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            // Fixed, as in MultiChoice: an 'absolute' portalled menu can loop with the page scroll (CD-5713).
            menuPosition='fixed'
            styles={dsSelectStyles}
          />
        )}
      </div>
    );
  }
}
